import { render, staticRenderFns } from "./interestdailybank.vue?vue&type=template&id=229068d6&"
import script from "./interestdailybank.vue?vue&type=script&lang=js&"
export * from "./interestdailybank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports